import { Button } from "@mui/material";
import React from "react";
import PropTypes from "prop-types";

const propTypes = {
	onAccept: PropTypes.func,
	onClear: PropTypes.func,
	onCancel: PropTypes.func,
	resetDateTime: PropTypes.func,
	submit: PropTypes.func,
	actions: PropTypes.array,
	clearTime: PropTypes.func
};

const defaultProps = {
	resetDateTime: () => { },
	submit: () => { },
	clearTime: () => { }
};

const DateTimePickerActionBar = ({ onAccept, onClear, onCancel, actions, resetDateTime, submit, clearTime }) => {
	const cancel = () => {
		resetDateTime();
		onCancel();
	};
	const ok = () => {
		submit();
		onAccept();
	};
	const clear = () => {
		clearTime();
		onClear();
	};
	return (
		<div style={{ display: "flex", padding: "6px" }}>
			<div style={{ flexBasis: "50%" }}>
				{actions[0] === null ? (
					<div></div>
				) : (
					<Button variant="text" onClick={clear} data-testid="orion-components-cbcomponents-date-time-custom-components-date-time-picker-date-time-picker-action-bar-button">
						{actions[0]}
					</Button>
				)}
			</div>
			<div style={{ flexBasis: "50%" }}>
				{actions[1] && (
					<Button variant="text" onClick={cancel} data-testid="orion-components-cbcomponents-date-time-custom-components-date-time-picker-date-time-picker-action-bar-button-2">
						{actions[1]}
					</Button>
				)}
				{actions[2] && (
					<Button variant="text" onClick={ok} data-testid="orion-components-cbcomponents-date-time-custom-components-date-time-picker-date-time-picker-action-bar-button-3">
						{actions[2]}
					</Button>
				)}
			</div>
		</div>
	);
};

DateTimePickerActionBar.propTypes = propTypes;
DateTimePickerActionBar.defaultProps = defaultProps;

export default DateTimePickerActionBar;
